import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Row, TextButton, Typography } from 'seagull';
import colors from 'seagull/foundations/colors.module.scss';
import { Location, PlusCircle } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { formatPostalAddress } from '~/utils/postalAddress/formatPostalAddress';
import { SectionCard } from '../SectionCard/SectionCard';
export const GetClientDetailsCardTID = (parentTestId)=>getTestIds(parentTestId);
export function ClientDetailsCard(param) {
    let { address, showAddAddress, referenceFieldsSubsection, isReadOnly, onEditClient, onAddAddress } = param;
    const { ClientDetailsCardTestIds: TID } = useMemo(()=>GetClientDetailsCardTID(), []);
    const { t: texts } = useLocaleKeys('client.detail.summary.clientDetails');
    const formattedAddress = address != null ? formatPostalAddress(address) : null;
    return /*#__PURE__*/ _jsx(SectionCard, {
        bi: {
            name: 'client_detail_client_details_card'
        },
        testId: TID.Root(),
        title: texts.title(),
        showActions: !isReadOnly,
        actions: /*#__PURE__*/ _jsx(TextButton, {
            bi: {
                name: 'client_detail_edit_client'
            },
            testId: TID.EditClientButton(),
            variant: "paragraph2",
            skin: "primary",
            weight: "normal",
            underline: "none",
            onClick: onEditClient,
            children: texts.editClient()
        }),
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 16,
            children: [
                formattedAddress != null && /*#__PURE__*/ _jsxs(Row, {
                    gap: 8,
                    alignItems: "start",
                    children: [
                        /*#__PURE__*/ _jsx(Location, {
                            size: 20,
                            style: {
                                color: colors.dark700
                            }
                        }),
                        /*#__PURE__*/ _jsxs(Column, {
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    testId: TID.Address.StreetLine(),
                                    variant: "paragraph2",
                                    skin: "secondary",
                                    children: formattedAddress.streetLine
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    testId: TID.Address.LocalityLine(),
                                    variant: "paragraph2",
                                    skin: "secondary",
                                    children: formattedAddress.localityLine
                                })
                            ]
                        })
                    ]
                }),
                showAddAddress && /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(TextButton, {
                        bi: {
                            name: 'client_detail_add_address'
                        },
                        testId: TID.AddAddressButton(),
                        variant: "paragraph2",
                        skin: "primary",
                        underline: "none",
                        prefixIcon: /*#__PURE__*/ _jsx(PlusCircle, {
                            size: 20
                        }),
                        onClick: onAddAddress,
                        children: texts.addAddress()
                    })
                }),
                referenceFieldsSubsection
            ]
        })
    });
}
